import { Link } from "react-router-dom";
import { AuthLayout } from "../components/AuthLayout";

export function CheckEmail() {
  return (
    <AuthLayout>
      <div className="auth-form">
        <h2>
          Check your <em>email.</em>
        </h2>
        <p>
          If an account exists for that address, we&rsquo;ve sent a reset link. It expires in 30
          minutes — check your spam folder if you don&rsquo;t see it.
        </p>
        <Link to="/sign-in" className="btn btn-primary btn-lg" style={{ justifyContent: "center" }}>
          Back to sign in
        </Link>
        <div className="auth-meta">Dev environment — no email is actually sent.</div>
      </div>
    </AuthLayout>
  );
}
